// src/utils/openTermsOfService.js
// ============================================================================
// One way to open the full Terms of Service from anywhere in the app.
//
// Web: a new tab on /tos, so whatever the member was doing (an entry modal, a
// half-filled form) stays put. No 'noopener' feature string: with it
// window.open ALWAYS returns null, and the in-app fallback below would fire on
// every click. The opener link is cut by hand instead.
// Popup blocked (window.open returned null), or native (no second tab): call
// onBeforeNavigate (e.g. close the RN <Modal> the link sits in, or it would
// cover the Terms) and navigate in-app to the read-only Terms screen.
//
// Call it synchronously inside the press handler (no await before it), or the
// browser treats the new tab as an unrequested popup and blocks it.
// ============================================================================

import { Platform } from 'react-native';

export function openTermsOfService(navigation, { onBeforeNavigate } = {}) {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const w = window.open('/tos', '_blank');
    if (w) {
      try { w.opener = null; } catch (_) {}
      return;
    }
  }
  onBeforeNavigate?.();
  navigation.navigate('TosAgreement', { readOnly: true });
}
